// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 6px;
}

.step-hint {
  color: #555;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}

.material-search-bar {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
.material-search-bar input {
  flex: 1;
}

.selected-material-badge {
  background: #e8f4e8;
  border: 1px solid #a3d9a5;
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.material-table-wrapper {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 0.75rem;
}

.test-type-list {
  columns: 2;
  column-gap: 1.5rem;
  margin-bottom: 0.75rem;
}
.test-type-list .form-check {
  break-inside: avoid;
  margin-bottom: 0.35rem;
}

.info-form {
  max-width: 520px;
}
.info-form .field-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  gap: 1rem;
}
.info-form .field-label {
  width: 120px;
  flex-shrink: 0;
  padding-top: 0.3rem;
  font-size: 0.875rem;
  color: #444;
}
.info-form .field-value {
  flex: 1;
}

.step-actions {
  margin-top: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
}

.clear-btn {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/mud-check-wizard/mud-check-wizard.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AACF;AACE;EACE,OAAA;AACJ;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,UAAA;EACA,kBAAA;EACA,sBAAA;AAAF;AAEE;EACE,mBAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAIE;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAKE;EACE,OAAA;AAHJ;;AAOA;EACE,mBAAA;EACA,mBAAA;EACA,0BAAA;AAJF;;AAOA;EACE,iBAAA;AAJF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 6px;\n}\n\n.step-hint {\n  color: #555;\n  font-size: 0.875rem;\n  margin-bottom: 0.75rem;\n}\n\n.material-search-bar {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 0.5rem;\n\n  input {\n    flex: 1;\n  }\n}\n\n.selected-material-badge {\n  background: #e8f4e8;\n  border: 1px solid #a3d9a5;\n  border-radius: 4px;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.85rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.material-table-wrapper {\n  max-height: 320px;\n  overflow-y: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 0.75rem;\n}\n\n.test-type-list {\n  columns: 2;\n  column-gap: 1.5rem;\n  margin-bottom: 0.75rem;\n\n  .form-check {\n    break-inside: avoid;\n    margin-bottom: 0.35rem;\n  }\n}\n\n.info-form {\n  max-width: 520px;\n\n  .field-row {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 0.75rem;\n    gap: 1rem;\n  }\n\n  .field-label {\n    width: 120px;\n    flex-shrink: 0;\n    padding-top: 0.3rem;\n    font-size: 0.875rem;\n    color: #444;\n  }\n\n  .field-value {\n    flex: 1;\n  }\n}\n\n.step-actions {\n  margin-top: 0.75rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid #eee;\n}\n\n.clear-btn {\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
